import { Add } from "@mui/icons-material";
import React from "react";
import { Box, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";

import ButtonCst from "@components/ButtonCst";
import { buildTestId, getRouteSection } from "@utils/utilsTestIds";
import {
  useIsSidebarLayout,
  useSidebarLandingItem,
} from "@context/sidebarLayout";

interface HeroProps {
  title: string;
  description: string;
  buttonLabel?: string;
}

const HeroCst: React.FC<HeroProps> = ({ title, description, buttonLabel }) => {
  const { area, section } = getRouteSection(useLocation().pathname);
  const isSidebarLayout = useIsSidebarLayout();
  const landingItem = useSidebarLandingItem();
  const heroTitle = landingItem?.title || title;
  const paddingTop = isSidebarLayout ? "16px" : "24px";

  return (
    <Box
      sx={{
        padding: description ? `${paddingTop} 0 16px` : `${paddingTop} 0 40px`,
      }}
    >
      <Typography
        variant="h3"
        component="h2"
        id={buildTestId(area, section, "page-title")}
        data-testid={buildTestId(area, section, "title")}
        aria-label={heroTitle}
        sx={{
          mb: "8px",
        }}
      >
        {heroTitle}
      </Typography>
      {description && (
        <Typography
          variant="subtitle2"
          sx={{
            mb: "24px",
          }}
        >
          {description}
        </Typography>
      )}
      {buttonLabel && (
        <ButtonCst id={"add-button"} variant={"contained"} text={buttonLabel}>
          <Add />
        </ButtonCst>
      )}
    </Box>
  );
};

export default HeroCst;
